const ENV_NAME = process.env.REACT_APP_BACKEND_ENVIRONMENT_NAME || 'test'

const ENV_LABELS: Record<string, string> = {
    test: 'Test',
    staging: 'Staging',
    prod: 'Production',
    produs: 'Production US',
}

export const envService = {
    name: ENV_NAME,
    label: ENV_LABELS[ENV_NAME] || 'Dev',
    isUS: ENV_NAME === 'produs',
    isProd: ENV_NAME === 'prod' || ENV_NAME === 'produs',
    companyDomain: ENV_NAME === 'test' ? 'auditech.xyz' : 'audit-tech.io',
    get dnsSuffix() {
        return this.isUS ? `.us.${this.companyDomain}` : `.${this.companyDomain}`
    },
    get bucketPrefix() {
        return this.isProd ? 'auditech-s3ws-' : 'auditech-frankfurt-s3ws-'
    },
}
